import styled from "styled-components";
import { css } from "styled-components";
import { desktop } from "../../_themes/constants";
import { getBackgroundColor } from "../../_themes/helpers";
import { FirefoxOnly } from "../../_utils/styleUtils";

const minHeightAndWidth = css`
  > * {
    min-height: 0;
    min-width: 0;
  }
`;

export const Wrapper = styled.div`
  pointer-events: all;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  background: ${getBackgroundColor("settingsWindow")};
  flex-direction: column;
  transition: opacity 200ms ease, z-index 0ms ease 200ms;
  user-select: initial;

  /* Full screen height - height of keypad wrapper */
  height: 100%;
  padding-bottom: ${desktop.keypadWrapper.height};

  /* Fix firefox bug where the buttons doesn't wrap */
  ${FirefoxOnly(minHeightAndWidth)};
`;
